export default {
    app: {
        title: 'Aurora Catch',
        subheader: 'Приложение-помощник для охоты за северным сиянием',
        feature_1: 'Смотрите оценку текущего уровня геомагнитной активности и вероятности сияния в вашей местности',
        feature_2: 'Прогнозируйте вероятность сияния от 50 минут до 2 часов вперед',
        feature_3: 'Получайте уведомления SWPC NOAA о прогнозируемых индексах геомагнитной активности',
        feature_4: 'Просматривайте графики параметров солнечного ветра',
        feature_5: 'Просматривайте камеры неба онлайн',
        delete_account_button: 'Удалить аккаунт',
        delete_account_title: 'Вы уверены что хотите удалить аккаунт?',
        go_back: 'Вернуться назад',
        yes: 'Да',
        delete_success: 'Аккаунт успешно удален',
        delete_fail: 'Не удалось удалить аккаунт',
    }
}
